import { isSuperAdmin } from 'services/user'

export const getUserTypesForRole = (role: Role): Role[] => {
  let roles: Role[] = ['user', 'org_admin']
  if (isSuperAdmin(role)) {
    roles = [...roles, 'account_admin']
  }
  return roles
}
